import { render, staticRenderFns } from "./CustomerLicenseList.vue?vue&type=template&id=85bc4540"
import script from "./CustomerLicenseList.vue?vue&type=script&lang=js"
export * from "./CustomerLicenseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports